import { render } from "./EducationCheckboxes.vue?vue&type=template&id=8f258f48"
import script from "./EducationCheckboxes.vue?vue&type=script&lang=js"
export * from "./EducationCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__